// extracted by mini-css-extract-plugin
module.exports = {"tour":"a10a3f92e9--tour--6WMNw","title":"a10a3f92e9--title--1HA82","content":"a10a3f92e9--content--2obwH","layout":"a10a3f92e9--layout--3lZtS"};